import React, { useState } from 'react';

export const ModalAccommodationRoomContext = React.createContext<{
  show: boolean;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
  viewAccommodationRoomId: number | undefined;
  setViewAccommodationRoomId: React.Dispatch<React.SetStateAction<number | undefined>>;
}>({
  show: false,
  setShow: () => {},
  viewAccommodationRoomId: undefined,
  setViewAccommodationRoomId: () => {},
});

const ModalAccommodationRoomProvider: React.ReactFCWithChildren = ({ children }) => {
  const [show, setShow] = useState(false);
  const [viewAccommodationRoomId, setViewAccommodationRoomId] = useState<number>();

  return (
    <ModalAccommodationRoomContext.Provider
      value={{ show, setShow, viewAccommodationRoomId, setViewAccommodationRoomId }}
    >
      {children}
    </ModalAccommodationRoomContext.Provider>
  );
};

export default ModalAccommodationRoomProvider
